import * as React from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.6667 1L4.66669 8L11.6667 15", stroke: "currentColor", strokeWidth: 2.8 }));
export default SvgChevronLeft;
